<template>
    <div class="consulAddDialog">
        <el-form ref="form" :model="form" label-width="110px">
            <el-form-item label="公示方式">
                <el-checkbox-group v-model="publicityList">
                    <el-checkbox label="0">张榜</el-checkbox>
                    <el-checkbox label="1">村务公开栏</el-checkbox>
                    <el-checkbox label="2">新媒体</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="公示时间">
                <el-date-picker
                    style="width: 600px"
                    v-model="form.publicityTime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetime"
                    placeholder="选择日期时间"
                ></el-date-picker>
            </el-form-item>
            <el-form-item label="发布网址">
                <el-input
                    v-model="form.publicityPlace"
                    style="width: 600px"
                ></el-input>
            </el-form-item>
            <el-form-item label="上传图片">
                <el-upload
                    :action="url"
                    list-type="picture-card"
                    :on-success="handleSuccess"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                >
                    <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog
                    :modal-append-to-body="false"
                    :visible.sync="dialogVisible"
                >
                    <img width="100%" :src="dialogImageUrl" alt="" />
                </el-dialog>
            </el-form-item>
            <el-form-item>
                <div class="boontbtn">
                    <el-button type="primary" @click="onSave">确定</el-button>
                    <el-button @click="quxiao">取消</el-button>
                </div>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { post } from "@/api/requrestHttp"
import baseURL from "@/api/baseURL"
export default {
    props: ["ytid"],
    data() {
        return {
           url:baseURL+
                "/ypt/controller/uploadVotePic/info/uploadPartyPhoto",
            dialogImageUrl: "",
            dialogVisible: false,
            id: this.ytid,
            value1: "",
            form: {},
            dialogImageUrl: "",
            dialogVisible: false,
            disabled: false,
            imageUrl: "",
            publicityList: [],
        }
    },
    methods: {
        onSave() {
            this.form.publicityMethods = this.publicityList + ""
            post("/admin/consultPublicity/info/updateConsultPublicity", {
                ...this.form,
                consultId: this.ytid,
            }).then((res) => {
                console.log(res)
                this.$emit("close")
            })
        },
        quxiao() {
            this.$emit("close")
            this.form = {}
            this.publicityList = []
            this.form.publicityMethods = ""
        },
        getData() {
            console.log("getData")
            this.form = {}
            this.publicityList = []
            this.imageUrl = ""
            this.form.photo = []
        },
        handleRemove(file, fileList) {
            console.log(file, fileList)
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url
            this.dialogVisible = true
        },
        handleDownload(file) {
            console.log(file)
        },
        onChange(file, fileList) {
            console.log(file)
            console.log(fileList)
        },
        handleAvatarSuccess(res, file) {
            console.log(res)
            console.log(file)
            this.imageUrl = URL.createObjectURL(file.raw)
            console.log(this.imageUrl)
        },
        handleSuccess(file, fileList) {
            console.log(file, fileList)
            console.log(file.content)
            this.form.photo = file.content
        },
        // getConsultPublicity() {
        //   if(this.form== null) {
        //     post("/admin/consultPublicity/info/getConsultPublicity",{
        //     consultId: this.id
        //     }).then(res => {
        //       console.log(res)
        //       console.log('5656565')
        //       this.form = res.content;
        //       this.publicityList = this.form.publicityMethods.split(',');
        //       console.log(this.publicityList)
        //     })
        //   }
        // }
    },
    mounted() {
        // this.getConsultPublicity();
    },
}
</script>

<style lang="less" scoped>
.consulAddDialog {
    .el-form-item {
        margin-bottom: 10px;
        .el-form-item__error {
            top: 85%;
        }
    }
}
.boontbtn {
    margin-top: 30px;
    display: flex;
    justify-content: center;
}
.queRenBtn {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    .qubtn {
        cursor: not-allowed;
        background-color: #ccc;
        color: #fff;
    }
    .qubtn :hover {
        cursor: not-allowed;
        background-color: #ccc;
        color: #fff;
    }
    .qubtn_span {
        color: #409eff;
        margin-top: 10px;
    }
}
</style>